import './polyfills';

import { createApp } from 'vue';

import { setupApp } from '@/app/setup';

import App from '@/app/App.vue';

const app = createApp(App);

setupApp(app);

app.mount('.main');
